import { useCallback } from "react";

import { RVButton } from "@regal-voice/ui";
import { useFlags } from "Services/FeatureFlagService";
import { useGlobalDialpad } from "Services/state/layout/useGlobalDialpad";
import useEventListener from "Utils/useEventListener/useEventListener";

import { AgentStats } from "./AgentStats/AgentStats";
import { SseConnectionDiagnostic } from "./SseConnectionDiagnostic/SseConnectionDiagnostic";

import styles from "./AgentNavBarButtons.module.scss";
export default function AgentNavBarButtons(): JSX.Element {
    const { showAgentDesktopStats, showAgentDesktopStatsAdvanced, sseConnectionDiagnostic } = useFlags();
    const { openDialpad } = useGlobalDialpad();

    const handleOpenDialpad = useCallback(() => {
        openDialpad({ context: "navbar" });
    }, [openDialpad]);

    const iframeMessageHandler = useCallback(
        (event: MessageEvent) => {
            if (event.data && event.data.source === "salesforce") {
                const action = event.data.action;
                const phone = event.data.phoneNumber;
                if (action === "open-dialer" && phone) {
                    openDialpad({
                        defaultPhoneNumber: phone,
                        context: "external-integration",
                    });
                }
            }
        },
        [openDialpad]
    );

    useEventListener("message", iframeMessageHandler);

    return (
        <>
            <span className={styles.buttonContainer}>
                {sseConnectionDiagnostic && <SseConnectionDiagnostic className={styles.diagnosticButton} />}
                <RVButton
                    data-testid="dialpad-button"
                    type="primary"
                    shape="circle"
                    icon="add"
                    onClick={handleOpenDialpad}
                />
                {(showAgentDesktopStats || showAgentDesktopStatsAdvanced) && (
                    <AgentStats showAdvancedStats={showAgentDesktopStatsAdvanced} />
                )}
            </span>
        </>
    );
}
